import { AffiliationType } from 'generated/graphql';

export const getAffiliationEnum = (type: string): AffiliationType => {
  switch (type) {
    case 'Board Member':
      return AffiliationType.BoardMember;

    case 'Family Member Affiliation':
      return AffiliationType.FamilyMemberAffiliation;

    case 'Personal Connection':
      return AffiliationType.PersonalConnection;

    default:
      return type as AffiliationType;
  }
};
